module.exports = __webpack_public_path__ + "img/hyperx.78400c1b.svg";